import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-response-banner',
  templateUrl: './response-banner.component.html',
  styleUrls: ['./response-banner.component.scss'],
  standalone: false,
})
export class ResponseBannerComponent implements AfterViewInit {
  @Input() success: boolean = true;
  @Input() successMessage: string = this.translate.instant(
    'response.banner.success',
  );
  @Input() errorMessage: string = this.translate.instant(
    'response.banner.error',
  );
  @Input() invisible: boolean = true;

  constructor(private translate: TranslateService) {}
  _transition: boolean = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._transition = true;
    });
  }
}
